import { Menu, MenuItem } from '@material-ui/core';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { ISegmentCurationAbTest, ISegmentCurationCollection, ISegmentCurationFeaturedCard } from '../../../services/types';
import { getStatusByDates } from '../../../services/utils/index';

interface IProps {
  item: ISegmentCurationFeaturedCard | ISegmentCurationCollection | ISegmentCurationAbTest;
  anchorEl: HTMLElement;
  onActivate?: () => void;
  onDelete?: () => void;
  onComplete?: () => void;
  onClose?: () => void;
}

export const MoreMenu = (props: IProps) => {
  const onClose = () => {
    props.onClose && props.onClose();
  };
  const dummyFunc = () => {};
  const status = getStatusByDates(props.item.startsAt, props.item.endsAt);

  return (
    <Menu anchorEl={props.anchorEl} keepMounted open={Boolean(props.anchorEl)} onClose={onClose}>
      {status === 'scheduled' && (
        <MenuItem key="more-c" onClick={props.onActivate || dummyFunc}>
          Activate
        </MenuItem>
      )}
      {(status === 'activated' || status === 'scheduled') && (
        <MenuItem key="more-complete" onClick={props.onComplete || dummyFunc}>
          Complete
        </MenuItem>
      )}
      {status === 'completed' && (
        <MenuItem key="more-delete" onClick={props.onDelete || dummyFunc}>
          Delete
        </MenuItem>
      )}
    </Menu>
  );
};
